var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgMetla(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0601 34.4163L24.5835 30.9398L48.6577 6.86552C49.1187 6.4045 49.744 6.14551 50.396 6.14551C51.048 6.14551 51.6733 6.4045 52.1343 6.86552C52.5953 7.32656 52.8543 7.95185 52.8543 8.60383C52.8543 9.25582 52.5953 9.8811 52.1343 10.3421L28.0601 34.4163Z",
    fill: "#D9925F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9777 53.6225C21.772 53.6229 21.5681 53.5831 21.3776 53.5054C16.8697 51.8828 12.9225 48.9997 10.0055 45.199C7.08841 41.3983 5.32418 36.8398 4.92253 32.0656C4.90161 31.8144 4.94014 31.5617 5.035 31.3282C5.12985 31.0946 5.27837 30.8867 5.46853 30.7212C5.65868 30.5557 5.88514 30.4372 6.12956 30.3755C6.37398 30.3138 6.6295 30.3105 6.87543 30.3659C10.9411 31.3298 15.2198 30.7533 18.8854 28.7476L18.9082 28.735L21.6766 27.2106C21.9624 27.0533 22.2895 26.9868 22.6141 27.0201C22.9387 27.0533 23.2455 27.1847 23.4935 27.3967L32.522 35.1036C32.7848 35.3278 32.9682 35.6309 33.0446 35.9678C33.1211 36.3047 33.0866 36.6572 32.9463 36.9729C32.9212 37.0314 32.1643 38.677 31.6102 39.8814L31.0416 41.1169C29.0867 45.5295 26.4155 49.5883 23.1361 53.1291C22.9862 53.2851 22.8064 53.4093 22.6073 53.4941C22.4082 53.5789 22.1941 53.6225 21.9777 53.6225Z",
    fill: "#FFD58C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2479 38.5853L21.1069 27.4443L24.6081 25.6938C25.352 25.3218 26.194 25.1933 27.015 25.3265C27.8359 25.4597 28.5942 25.8479 29.1823 26.4359L33.256 30.5099C33.8441 31.098 34.2323 31.8562 34.3655 32.6772C34.4988 33.4981 34.3703 34.3402 33.9984 35.0841L32.2479 38.5853Z",
    fill: "#FA6D62"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7158 9.80749L35.2861 20.2373L38.7627 23.7138L49.1924 13.284L45.7158 9.80749Z",
    fill: "#FA6D62"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9881 47.4003C14.9804 45.1592 17.5758 42.4323 19.6665 39.333C15.9022 40.9031 11.8713 41.7351 7.79297 41.7837C8.91015 43.8504 10.3235 45.7426 11.9881 47.4003Z",
    fill: "#D9925F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetla);
export default __webpack_public_path__ + "static/media/metla.a06f206741f49d743b0a692dee5f0ca1.svg";
export { ForwardRef as ReactComponent };